/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { DeleteReportDefinitionMutationResponse, DeleteReportDefinitionPathParams, DeleteReportDefinition400, DeleteReportDefinition404 } from "../models/DeleteReportDefinition";

export function getDeleteReportDefinitionUrl(id: DeleteReportDefinitionPathParams["id"]) {
  const res = { method: 'DELETE', url: `/report-definitions/${id}` as const }
  return res
}

/**
 * @description Deletes a report definition by its unique identifier. Cannot delete if it is the only definition for the report type or if it is the default definition.
 * @summary Delete report definition
 * {@link /report-definitions/:id}
 */
export async function deleteReportDefinition(id: DeleteReportDefinitionPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteReportDefinitionMutationResponse, ResponseErrorConfig<DeleteReportDefinition400 | DeleteReportDefinition404>, unknown>({ method : "DELETE", url : getDeleteReportDefinitionUrl(id).url.toString(), ... requestConfig })
  return res.data
}